import _ from 'underscore';
import decimal from '@bingads-webui-component-legacy/humanize/decimal';

export function getTrafficEstimationOp(adGroup, bid, budget, locationIds = [190], languages = []  ) {
  let adGroupRequests;

  if (_.isArray(adGroup)) {
    adGroupRequests = _.map(adGroup, (item) => {
      return {
        'AdGroupName': item.Name,
        'KeywordTrafficEstimateParameters': _.map(item.Keywords, (keyword) => {
          return {
            'MatchType': keyword.MatchType,
            'Text': keyword.Text,
          };
        }),
        'MaxCPC': decimal.fromLocalToFloat(item.Bid),
      };
    });
  } else {
    adGroupRequests = [{
      'AdGroupName': adGroup.Name,
      'KeywordTrafficEstimateParameters': _.map(adGroup.Keywords, (keyword) => {
        return {
          'MatchType': keyword.MatchType,
          'Text': keyword.Text,
        };
      }),
      'MaxCPC': decimal.fromLocalToFloat(bid),
    }];
  }

  const targetings = _
    .chain(locationIds)
    .compact()
    .map((locationId) => {
      return {
        '@odata.type': '#Model.TrafficEstimate.LocationTargeting',
        'LocationId': locationId,
      };
    }).value();

  // send it when trafficestimation support more than one language in multi-language pilot
  if (!_.isEmpty(languages)) {
    _.each(languages, (language) => {
      targetings.push({
        '@odata.type': '#Model.TrafficEstimate.LanguageTargeting',
        'Language': language,
      });
    });
  }

  let op = {
    data: {
      'CampaignTrafficEstimate': {
        'AdGroupTrafficEstimateParameters': adGroupRequests,
        'Budget': decimal.fromLocalToFloat(budget),
        'Targetings': targetings,
      },
    },
    path: 'AdInsight/V2',
    // host: 'http://stcvm-607:823/', // for local debug only
  };

  return op;
}

export function getDailyBudgetAmount(budgetObj) {
  return budgetObj.Type === 'Monthly' ? budgetObj.Amount / 30 : parseFloat(budgetObj.Amount);
}
